import React, { useCallback, useEffect, useMemo, useState } from "react";
import { API_URLS } from "../../../api/apiUrls";
import { getApi } from "../../../api/api_instance";
import { ReactComponent as EyeIcon } from "../../../assets/svgs/greenEye.svg";
import { ReactComponent as EditIcon } from "../../../assets/svgs/edit-icon.svg";
import { ReactComponent as CopyIcon } from "../../../assets/svgs/greenFile.svg";
import dayjs from "dayjs";
import CardsBorder from "../../../components/Cards/CardsBorder";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../components/Elements/Tables/Tables";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import AddNewDynamicForm from "./Roles/DIalogBoxes/AddNewDynamicForm";
import CopyCustomerDynamicForm from "./Roles/DIalogBoxes/CopyCustomerDynamicForm";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";

const CustomerDynamicForms = ({ clientId }) => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [openAddNew, setOpenAddnew] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [openCopyForm, setOpenCopyForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [popup, setPopup] = useState({
    visible: false,
    type: "",
    title: "",
    message: "",
  });

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Form Name", key: "formName" },
      { label: "Created On", key: "createdOn" },
      { label: "Action", key: "action" },
    ],
    []
  );

  const showPopup = (type, title, message) => {
    setPopup({ visible: true, type, title, message });

    setTimeout(() => {
      setPopup({ visible: false, type: "", title: "", message: "" });
    }, 3000); // Close after 3 seconds
  };

  const fetchCustomForms = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_CUSTOMFORMS,
        headers: { client: clientId },
      });

      const apiData = response.data.data;

      const formattedData = apiData.map((item, index) => ({
        key: item._id,
        serial: index + 1,
        formName:<div className="text-center">{item.title}</div>,
        createdOn: <div className="text-center">{dayjs(item.createdAt).format("DD MMM YYYY")}</div>,
        action: (
          <div className="flex gap-4 items-center justify-center">
            <EyeIcon style={{ cursor: "pointer" }} onClick={() => {}} />
            <EditIcon style={{ cursor: "pointer" }} onClick={() => {}} />
            <CopyIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                setOpenCopyForm(true);
                setSelectedForm(item);
              }}
            />
          </div>
        ),
      }));

      setTableData(formattedData);
    } catch (error) {
      console.error("Error is fetching Dynamic Forms", error);
    }
  };

  const handleSearch = useCallback((searchTerm) => {
    setSearchTerm(searchTerm);
  }, []);

  const handleOpenAddNew = () => {
    console.log("hello");
    setOpenAddnew(true);
  };

  useEffect(() => {
    if (clientId) {
      fetchCustomForms();
    }
    console.log("Client id is", clientId)
  }, [clientId]);
  return (
    <div
     style={{paddingLeft:"40px",paddingRight:"40px",paddingTop:"20px"  }}
    >
      <CardsBorder>
        <div className="flex justify-between my-4 font-medium px-10">
          <div className="flex gap-8">
            <p className="text-[#06513D] pt-2  text-xl">Dynamic Forms</p>
            <SearchBar width="300px" onSearch={setSearchTerm} />
          </div>
          <CustomButton
            buttonType="button"
            variant="ok"
            buttonText="+ ADD NEW"
            className="text-sm h-[50px]"
            onClick={() => setOpenAddnew(true)} // ✅ Simple & Safe
          />
        </div>
        <Tables data={tableData} headers={headers} />
      </CardsBorder>
      {openAddNew && (
        <AddNewDynamicForm
          onOpen={openAddNew}
          onClose={() => {
            setOpenAddnew(false);
            fetchCustomForms();
          }}
          clientId={clientId}
          showPopup={showPopup} // ✅ Pass popup handler
        />
      )}

      {openCopyForm && (
        <CopyCustomerDynamicForm
          onOpen={openCopyForm}
          onClose={() => setOpenCopyForm(false)}
          data={selectedForm}
          onSave={async () => {
            await fetchCustomForms();
            setOpenCopyForm(false);
          }}
          clientId={clientId}
          showPopup={showPopup} // ✅ Pass popup handler
        />
      )}

      {/* {showSuccess && (
        <SuccessDailogBox
          onOpen={showSuccess}
          onClose={() => setShowSuccess(false)}
          successMessage={"Dynamic Form Copied Successfully"}
          messageTitle={"Success"}
          popuptype="document"
        />
      )} */}

      {popup.visible && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
          />
        </div>
      )}
    </div>
  );
};

export default CustomerDynamicForms;
